import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDropdownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 12 6"
    fill="none"
    stroke="#919499"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m1 1 5.033 4L11 1" strokeLinecap="round" />
  </svg>
);
const Memo = memo(SvgDropdownArrow);
export default Memo;
